var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledrightchevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32393 18.7071C7.93341 18.3166 7.93341 17.6834 8.32393 17.2929L13.6168 12L8.32393 6.7071C7.93341 6.31658 7.93341 5.68342 8.32393 5.29289C8.71445 4.90237 9.34762 4.90237 9.73814 5.29289L15.6321 11.1868C16.0812 11.6359 16.0812 12.3641 15.6321 12.8132L9.73814 18.7071C9.34762 19.0976 8.71445 19.0976 8.32393 18.7071Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledrightchevron);
export default __webpack_public_path__ + "static/media/disabledrightchevron.845c1d97f8692665825a401019c13f15.svg";
export { ForwardRef as ReactComponent };